var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"welcome-bg"}),_c('div',{staticClass:"welcome-content"},[_c('h2',[_vm._v(" "+_vm._s(_vm.$t('com_hi'))+","),(_vm.userInfo)?_c('span',[_vm._v(_vm._s(_vm.userInfo.user.userName)+",")]):_vm._e(),_c('i',[_vm._v(_vm._s(_vm.$t('com_welcome')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }